export const serviceLogMatrixPath = {
  PULL_SERVICE_LOG: '/service_log_matrix/pull',
  RETRIEVE_BATCH: '/service_log_matrix/batch/retrieve'
};